export const Divider = () => (
    <hr className="my-10 h-px w-full bg-primary-white" />
);
